import { TableCell } from "@mui/material";
import { StyledFooterCell, StyledTableFooterWrapper } from "./Table.style";

import spliter from "helper/digit-spliter";

export default function EnhancedTableFooter(props) {
  const { factorInfo } = props;

  return (
    <>
      <StyledTableFooterWrapper>
        <TableCell></TableCell>
        <StyledFooterCell></StyledFooterCell>
        <StyledFooterCell></StyledFooterCell>
        <StyledFooterCell>تخفیف :</StyledFooterCell>
        <StyledFooterCell>{spliter(factorInfo.discount)}</StyledFooterCell>
      </StyledTableFooterWrapper>
      <StyledTableFooterWrapper>
        <TableCell></TableCell>
        <StyledFooterCell>جمع تعداد :</StyledFooterCell>
        <StyledFooterCell>{spliter(factorInfo.totalCount)}</StyledFooterCell>
        <StyledFooterCell>جمع کل :</StyledFooterCell>
        <StyledFooterCell>{spliter(factorInfo.totalPrice)}</StyledFooterCell>
      </StyledTableFooterWrapper>
    </>
  );
}
